export type Variant = 'A' | 'B';

const STORAGE_KEY = 'seo-ab-variant';

export const getAssignedVariant = (): Variant => {
  try {
    const existing = localStorage.getItem(STORAGE_KEY) as Variant | null;
    if (existing === 'A' || existing === 'B') return existing;
    const assigned: Variant = Math.random() < 0.5 ? 'A' : 'B';
    localStorage.setItem(STORAGE_KEY, assigned);
    return assigned;
  } catch {
    return 'A';
  }
};

export const trackAbView = (page: string, variant: Variant) => {
  try {
    (window as any).gtag?.('event', 'seo_ab_view', { page, variant });
  } catch {}
};

export const trackAbClick = (page: string, variant: Variant, label?: string) => {
  try {
    (window as any).gtag?.('event', 'seo_ab_click', { page, variant, label });
  } catch {}
};









